import { useContext, useEffect } from 'react';
import { MainNavigationContext } from '../MainNavigationContext';
export function useNavigationItemHandler(linkRef, isLinkActive) {
    /**
     * These context values are provided by »useHighlightSwoosh« through
     * the »MainNavigation«
     */
    const { registerNavigationItem: register, unregisterNavigationItem: unregister, updateActiveNavigationItem: update, } = useContext(MainNavigationContext);
    /**
     * This is used in »useHighlightSwoosh«
     * This effect (on mount) registers or adds the item in the main component
     * On unmount it calls "unregister" and removes the item from the list
     */
    useEffect(() => {
        const element = linkRef.current;
        if (!element) {
            return;
        }
        register(element);
        return () => {
            unregister(element);
        };
    }, [linkRef, register, unregister]);
    /**
     * Callback for update the navigation item (used in »MainNavigation«)
     */
    useEffect(() => {
        const element = linkRef.current;
        if (!element) {
            return;
        }
        update(element, isLinkActive);
    }, [update, isLinkActive, linkRef]);
}
